export const MONETATE_URL =
  'https://engine.monetate.net/api/engine/v1/decide/JohnLewis'
